gsap.registerPlugin(ScrollTrigger);

const products = document.querySelectorAll(".product-item");

products.forEach((el, i) => {

  let start = i * 300;
  let end = start + 300;

  gsap.fromTo(el,
    { opacity: 0, scale: 0.8 },
    {
      opacity: 1,
      scale: 1,
      scrollTrigger: {
        trigger: ".scroll-hero",
        start: `top+=${start} center`,
        end: `top+=${end} center`,
        scrub: true
      }
    }
  );

});